<template>
  <div class="header">
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :show-close="false"
      size="290px"
      :withHeader="false"
    >
      <div class="nav-title">
        <div class="nav-back" @click="handleClose">
          <img
            src="../assets/image/sj-tabbar-back.png"
            alt=""
            class="img-fluid"
          />
        </div>
        <div class="nav-logo">
          <img src="../assets/image/logo.png" alt="" class="img-fluid" />
        </div>
      </div>
      <ul class="nav-path">
        <li>
          <router-link tag="a" to="/home" href="javascript:;">
            {{ $t("header.home") }}
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/aboutus" href="javascript:;">
            {{ $t("header.about") }}
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/cases" href="javascript:;">
            {{ $t("header.cases") }}
          </router-link>
          <div class="side_menu">
<!--            <li>-->
<!--              <router-link tag="a" to="/cases/part1" href="javascript:;"-->
<!--                >{{ $t("header.equipment") }}-->
<!--              </router-link>-->
<!--            </li>-->
<!--            <li>-->
<!--              <router-link tag="a" to="/cases/part2" href="javascript:;"-->
<!--                >{{ $t("header.Projectsunderconstruction") }}-->
<!--              </router-link>-->
<!--            </li>-->
<!--            <p>-->
              <p  href="javascript:;" @click="onPart" :style="{color:color}">
                {{ $t("header.equipment") }}
              </p>
<!--            </p>-->
<!--            <p >-->
              <p href="javascript:;"@click="onPartT" :style="{color:colorT}"
              >{{ $t("header.Projectsunderconstruction") }}
              </p>
<!--            </p>-->
<!--            </li>-->
          </div>
  </li>
        <li>
          <router-link tag="a" to="/equip&tech" href="javascript:;">
            {{ $t("header.technology") }}
          </router-link>
        </li>
        <!-- <li>
          <router-link tag="a" to="/equipment" href="javascript:;">
            {{ $t('header.equipment') }}
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/technology" href="javascript:;">
            {{ $t('header.technology') }}
          </router-link>
        </li> -->
        <li>
          <router-link tag="a" to="/news" href="javascript:;">
            {{ $t("header.news") }}
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/contactus" href="javascript:;">
            {{ $t("header.contactus") }}
          </router-link>
        </li>
      </ul>
    </el-drawer>

    <div class="top">
      <div class="top_container container">
        <span>{{ $t("header.welcome") }}</span>
        <div class="language">
          <a href="javascript:;" @click="changeLanguage_zh()">中文</a>
          |
          <a href="javascript:;" @click="changeLanguage_en()">ENGLISH</a>
        </div>
      </div>
    </div>

    <div class="nav_container container">
      <div class="">
        <a href="javascript:;" class="nav-toggler" @click="drawer = true">
          <img
            src="../assets/image/mobile-tabbar.png"
            class="img-fluid"
            alt="img"
          />
        </a>
      </div>
      <router-link tag="div" to="/home" class="logo">
        <img :src=enlogo class="img-fluid" alt="logo" v-if="this.$i18n.locale=='en'"/>
        <img :src=zhlogo class="img-fluid" alt="logo" v-if="this.$i18n.locale=='zh'"/>
      </router-link>
      <div class="text-right">
        <a
          href="javascript:;"
          class="toggler-language"
          @click="changeLanguage()"
        >
          {{ $t("language.name") }}
        </a>
      </div>

      <ul class="tabbar">
        <li>
          <router-link tag="a" to="/home" href="javascript:;">
            {{ $t("header.home") }}
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/aboutus" href="javascript:;"
            >{{ $t("header.about") }}
          </router-link>
        </li>
        <li class="dropDown-menu-box">
          <router-link tag="a" to="/cases" href="javascript:;">
            {{ $t("header.cases") }}
            <img src="../assets/image/header-more.png" class="icon" alt="" />
          </router-link>
          <ul class="dropDown-menu">
            <li>
              <p  href="javascript:;" @click="onPart" :style="{color:color}">
                {{ $t("header.equipment") }}
              </p>
            </li>
            <li>
              <p href="javascript:;"@click="onPartT" :style="{color:colorT}"
              >{{ $t("header.Projectsunderconstruction") }}
              </p>
            </li>
          </ul>
        </li>
        <li>
          <router-link tag="a" to="/equip&tech" href="javascript:;">
            {{ $t("header.technology") }}</router-link
          >
        </li>
        <li>
          <router-link tag="a" to="/news" href="javascript:;"
            >{{ $t("header.news") }}
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/contactus" href="javascript:;">
            {{ $t("header.contactus") }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import zhlogo from '../assets/image/logo.png'
import enlogo from '../assets/image/logoEn.png'
export default {
  components: {},
  props: {},
  data() {
    return {
      drawer: false,
      direction: "ltr",
      zhlogo,
      enlogo,
      color:'',
      colorT:''
    };
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
        console.log(val);
        if(val.name=='Cases_part1'){
          this.color='#064ea4'
        }else if(val.name=='Cases_part2'){
          this.colorT='#064ea4'
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {},
  inject: ["reload"],
  methods: {
    onPart(){
      this.color='#064ea4'
      this.colorT=''
      this.drawer = false;
      this.$router.push('/cases/part1')

    },
    onPartT(){

      this.colorT='#064ea4'
      this.color=''
      this.drawer = false;
      console.log(  this.drawer,"  this.drawer333")
      this.$router.push('/cases/part2')

    },
    handleClose(done) {
      this.drawer = false;
    },
    changeLanguage_en() {
      this.$i18n.locale == "zh" ? (this.$i18n.locale = "en") : ""; //设置中英文模式
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
      this.reload();
    },
    changeLanguage_zh() {
      this.$i18n.locale == "en" ? (this.$i18n.locale = "zh") : ""; //设置中英文模式
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
      this.reload();
    },
    changeLanguage() {
      this.$i18n.locale == "zh"
        ? (this.$i18n.locale = "en")
        : (this.$i18n.locale = "zh"); //设置中英文模式
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
      this.reload();
    },
  },
  created() {

  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.header {
  position: fixed;
  background-color: #fff;
  z-index: 1000;
  width: 100%;
  border-bottom: 1px solid #eee;
  .top {
    height: 30px;
    background: #054ea4;
    color: #ffffff;

    .top_container {
      display: flex;
      justify-content: space-between;
      line-height: 30px;
      font-size: 16px;
      span {
        color: #ffffff;
      }
      .language {
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
    }
  }
  .nav_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 110px;
    .toggler-language {
      color: #333333;
      font-size: 14px;
      display: none;
    }
    .nav-toggler {
      display: block;
      width: 26px;
      height: 19px;
      display: none;
      line-height: 19px;
      img {
        width: 100%;
      }
    }
    .logo {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tabbar {
      flex: 3;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 0;
      .dropDown-menu-box:hover {
        .icon {
          transform: rotate(180deg);
        }
        .dropDown-menu {
          display: block;
        }
      }
      > li {
        padding-left: 38px;
        position: relative;
        white-space: nowrap;

        .dropDown-menu {
          position: absolute;
          left: 27px;
          width: 100%;
          background-color: #ffffff;
          padding: 23px 0 10px 13px;
          display: none;

          li {
            padding-bottom: 10px;
            a {
              font-size: 16px;
              font-weight: 400;
            }
          }
        }
        a {
          color: #333333;
          font-size: 20px;
          &.router-link-active {
            font-weight: 800;
            color: #064ea4;
          }
        }
      }
    }
  }
}

//侧边栏
.nav-title {
  display: flex;
  padding: 15px;
  align-items: center;

  box-shadow: 0px 0px 13px 5px rgba(159, 161, 163, 0.445);
  .nav-back {
    width: 5%;
    margin-right: 55px;
  }
  .nav-logo {
    width: 50%;
  }
}
.nav-path {
  margin-top: 25px;
}
.nav-path li a {
  display: block;
  font-size: 23px;
  font-weight: 800;
  color: #343434;
  line-height: 60px;
  padding-left: 40px;
  margin-bottom: 20px;
  &.router-link-active {
    background: url("../assets/image/sj-tabbar.png") no-repeat;
    background-size: cover;
    border-left: 5px solid #0465d7;
    color: #064ea4;
  }
}
.side_menu {
  /*display: flex;*/

  p:nth-child(1) {
    /*padding: 0;*/
    /*margin: 0;*/
    /*text-indent: 1rem;*/
    /*margin-top: -10px;*/
    /*border: 1px solid red;*/
    margin-bottom: 0px;
    padding-left: 60px;
    margin-top: -10px;
    a {
      font-weight: 400;
      font-size: 19px !important;
    }
  }
  p:nth-child(2){

    margin-top: 5px;
    margin-bottom: 20px;
    padding-left: 60px;
  }
}
.side_menu li a.router-link-active {
  font-size: 19px;
  color: #054ea4;
  background: none;
  border: none;
}
/deep/.el-drawer__container {
  background-color: rgba(0, 0, 0, 0.445);
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .header .nav_container .tabbar li a {
    font-size: 20px;
  }
}
@media (max-width: 1024px) {
  .header .nav_container .tabbar li {
    padding-left: 15px;
    a {
      font-size: 18px;
    }
  }
}
//ipad  端样式
@media (max-width: 1024px) and (min-width: 768px) {
  .header .top {
    display: none;
  }
  .header .nav_container {
    height: 75px;
  }
  .header .nav_container .tabbar {
    display: none;
  }
  .header .nav_container .nav-toggler {
    display: block;
    flex: 1;
    width: 39px;
    height: 28px;
  }
  .header .nav_container .toggler-language {
    display: block;
    font-size: 22px;
    flex: 1;
  }
  .header .nav_container .logo {
    flex: 1;
    img {
      width: 227px;
    }
  }
  .nav-path li a {
    font-size: 23px;
    line-height: 40px;
  }
}
//手机端  端样式
@media (max-width: 767px) and (min-width: 320px) {
  .header .top {
    display: none;
  }
  .header .nav_container {
    height: 50px;
  }
  .header .nav_container .tabbar {
    display: none;
  }
  .header .nav_container .nav-toggler {
    display: block;

    flex: 1;
  }
  .header .nav_container .toggler-language {
    display: block;

    flex: 1;
  }
  .header .nav_container .logo {
    flex: 1;
    img {
      width: 101px;
    }
  }
  .nav-path li a {
    font-size: 18px;
    line-height: 40px;
  }
}
</style>
